// import { createApi } from '@reduxjs/toolkit/query/react';
// import { baseQuery } from '../../../utils';
// import { createPriceType, listPriceType } from '../../../graphql';
// import type {
//   CreatePriceTypeMutationVariables,
//   CreatePriceTypeMutation,
//   ListPriceTypeQueryVariables,
//   ListPriceTypeQuery,
// } from '../../../graphql/API';
// import { PriceRowData, PriceRowDataApi } from '../../CompanycodeTranslation/components/PriceRowData';

// export const priceTypeApi = createApi({
//   reducerPath: 'PriceTypeApi',
//   baseQuery: baseQuery,
//   tagTypes: ['getPriceSettings'],
//   endpoints: (builder) => ({
//     listPriceTypes: builder.query<PriceRowDataApi[], ListPriceTypeQueryVariables>({
//       query: (variables) => ({ body: listPriceType, variables }),
//       keepUnusedDataFor: 1,
//       providesTags: ['getPriceSettings'],
//       transformResponse: (response: ListPriceTypeQuery) => {
//         console.log('priceType.api.ts transformResponse - response:', response.listPriceType);
//         const transformed =
//           response?.listPriceType
//             ?.filter((item) => item !== null && item !== undefined)
//             .map((item) => ({
//               label: item?.pricetype || '',
//               value: item?.id || 0,
//               tableType: item?.tabletype ,
//               raw: item ,
//             })) || [];
//         return transformed;
//       },
//     }),
//     // createPriceType: builder.mutation<CreatePriceTypeMutation, CreatePriceTypeMutationVariables>({
//     //   query: (variables) => ({ body: createPriceType, variables }),
//     //   invalidatesTags: ['getPriceSettings'],
//     // }),
//     createPriceType: builder.mutation<CreatePriceTypeMutation, CreatePriceTypeMutationVariables>({
//       query: (variables) => ({
//         body: createPriceType,
//         variables,
//       }),
//       invalidatesTags: ['getPriceSettings'],
//     }),
//   }),
// });

// export const { useCreatePriceTypeMutation, useListPriceTypesQuery } = priceTypeApi;
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import { createPriceType, listPriceType } from '../../../graphql';
import type {
  CreatePriceTypeMutationVariables,
  CreatePriceTypeMutation,
  ListPriceTypeQueryVariables,
  ListPriceTypeQuery,
} from '../../../graphql/API';
import { PriceRowDataApi } from '../../CompanycodeTranslation/components/PriceRowData';

export const priceTypeApi = createApi({
  reducerPath: 'priceTypeApi',
  baseQuery: baseQuery,
  tagTypes: ['priceTypeSettings'],
  endpoints: (builder) => ({

    listPriceTypes: builder.query<PriceRowDataApi[], ListPriceTypeQueryVariables>({
      query: (variables) => ({
        body: listPriceType,
        variables,
      }),
      keepUnusedDataFor: 1,
      providesTags: ['priceTypeSettings'],

      transformResponse: (response: ListPriceTypeQuery) => {
        console.log('priceType.api transformResponse - response:', response.listPriceType);

        const transformed =
          response?.listPriceType
            ?.filter((item) => item !== null && item !== undefined)
            .map((item) => ({
              label: item?.pricetype || '',
              value: item?.id || 0,
              tableType: item?.tabletype,
              raw: item,
            })) || [];

        return transformed;
      },
    }),
    createPriceType: builder.mutation<CreatePriceTypeMutation, CreatePriceTypeMutationVariables>({
      query: (variables) => ({
        body: createPriceType,
        variables,
      }),
      invalidatesTags: ['priceTypeSettings'],
    }),
  }),
});

export const { 
  useListPriceTypesQuery,
  useLazyListPriceTypesQuery,
  usePrefetch,
  useCreatePriceTypeMutation 
} = priceTypeApi;


